"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const i18n_1 = require("@completeanatomy/i18n");
const licenses_1 = require("@completeanatomy/licenses");
const ui_1 = require("@completeanatomy/ui");
const react_1 = require("react");
const react_i18next_1 = require("react-i18next");
const styled_components_1 = __importDefault(require("styled-components"));
const index_1 = require("../../index");
const InviteMultipleMembersButton_1 = __importDefault(require("../../molecules/InviteMultipleMembersButton"));
const filter_1 = require("../../utils/filter");
const license_1 = require("../../utils/license");
const sort_1 = require("../../utils/sort");
const index_2 = require("../index");
// eslint-disable-next-line max-lines-per-function
function GroupsManagement({ setCurrentGroup, groups, currentGroup, isMobile, isCtaCardVisible, setCtaCardVisible, }) {
    const { t } = (0, react_i18next_1.useTranslation)();
    const [sortedGroups, setSortedGroups] = (0, react_1.useState)(groups);
    const [foundedGroups, setFoundedGroups] = (0, react_1.useState)(groups);
    const [participatingGroups, setParticipatingGroups] = (0, react_1.useState)(groups);
    const [sortIndex, setSortIndex] = (0, react_1.useState)(0);
    const licenses = (0, licenses_1.useUserLicenses)();
    const isEducatorLicence = licenses
        ? (0, license_1.getActiveEduLicence)(licenses)
        : undefined;
    (0, react_1.useEffect)(() => {
        (0, sort_1.sortGroups)(sortIndex, groups, setSortedGroups);
    }, [groups, sortIndex]);
    const localizedSortOptions = sort_1.SORT_OPTIONS.map(sortType => (0, sort_1.getLocalizedSortOption)(sortType, t));
    (0, react_1.useEffect)(() => {
        setFoundedGroups((0, filter_1.getFoundedGroups)(sortedGroups));
        setParticipatingGroups((0, filter_1.getParticipatingGroups)(sortedGroups));
    }, [sortedGroups]);
    (0, react_1.useEffect)(() => {
        const selectedGroup = groups.find(({ identifier }) => identifier === currentGroup);
        if (selectedGroup) {
            return;
        }
        const firstVisibleGroup = foundedGroups.find(group => group.canLeave) ||
            participatingGroups.find(group => group.canLeave);
        if (firstVisibleGroup) {
            setCurrentGroup(firstVisibleGroup.identifier);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [foundedGroups, participatingGroups, setCurrentGroup]);
    const onSelect = (group) => {
        setCurrentGroup(group.identifier);
    };
    const onSort = (index) => {
        setSortIndex(index);
    };
    const groupNameFilter = (groupsToFilter) => {
        return groupsToFilter.filter(({ name }) => name.toLowerCase().includes(searchValue.toLowerCase()));
    };
    const searchProps = {
        placeholder: t(i18n_1.Strings.settings.sharing.searchPlaceholder),
        searchButtonStyle: {
            width: '16px',
            height: '16px',
            margin: 'auto 10px auto 0',
        },
    };
    const { search, searchValue } = (0, ui_1.useSearch)({
        type: ui_1.SearchType.Field,
        SearchField: StyledSearch,
        canBeCleared: true,
        searchProps,
    });
    const isEmpty = !groupNameFilter(groups).length;
    return ((0, jsx_runtime_1.jsxs)(Container, { "data-e2e": 'GroupsManagement_Container', children: [(0, jsx_runtime_1.jsxs)(FilterContainer, { "data-e2e": 'GroupsManagement_FilterContainer', children: [search, (0, jsx_runtime_1.jsx)(SortDropdown, { label: (0, i18n_1.Localized)(i18n_1.Strings.settings.sharing.sortBy), items: localizedSortOptions, currentIndex: sortIndex, onSelect: onSort, "data-e2e": 'GroupsManagement_SortDropdown' })] }), isEducatorLicence && ((0, jsx_runtime_1.jsx)(InviteMultipleMembersButton_1.default, { buttonText: (0, i18n_1.Localized)(i18n_1.Strings.settings.sharing.gotoDashboard), hint: (0, i18n_1.Localized)(i18n_1.Strings.settings.sharing.needInviteMultiple), "data-e2e": 'GroupsManagement_InviteMultipleMembersButton' })), isEmpty && groups.length > 0 ? ((0, jsx_runtime_1.jsx)(index_1.EmptyGroupList, { "data-e2e": 'GroupsManagement_EmptyGroupList' })) : ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(index_2.GroupList, { title: (0, i18n_1.Localized)(i18n_1.Strings.settings.sharing.myGroups), groups: groupNameFilter(foundedGroups), selected: currentGroup, onSelect: onSelect, showCreateGroupButton: true, isMobile: isMobile, isCtaCardVisible: isCtaCardVisible, setCtaCardVisible: setCtaCardVisible, isMyGroups: true, "data-e2e": 'GroupsManagement_GroupList' }), participatingGroups.length > 0 && ((0, jsx_runtime_1.jsx)(index_2.GroupList, { title: (0, i18n_1.Localized)(i18n_1.Strings.settings.sharing.belongGroups), groups: groupNameFilter(participatingGroups), selected: currentGroup, onSelect: onSelect, isMobile: isMobile, "data-e2e": 'GroupsManagement_GroupList' }))] }))] }));
}
exports.default = GroupsManagement;
const Container = styled_components_1.default.div `
  height: 100%;
  box-sizing: border-box;

  display: flex;
  flex-basis: 60%;
  flex-direction: column;
  flex-shrink: 0;

  min-width: 60%;

  padding: 20px 0 0 0;

  overflow: hidden;

  border-right: 1px solid ${props => props.theme.secondary};
`;
const FilterContainer = styled_components_1.default.div `
  display: flex;
  flex-shrink: 0;

  width: 100%;
`;
const StyledSearch = (0, styled_components_1.default)(ui_1.SearchField) `
  flex-basis: 50%;

  height: 40px;

  padding: 0 10px;

  background-color: ${props => props.theme.backgroundSecondary};

  border-radius: 20px;

  box-shadow: ${props => props.theme.store.buttonShadow};
`;
const SortDropdown = (0, styled_components_1.default)(ui_1.DropdownSelect) `
  flex-basis: 50%;

  height: 40px;

  margin: 0 10px;
`;
